import { render, staticRenderFns } from "./AdminCustomersList.vue?vue&type=template&id=7fe567c0&scoped=true&"
import script from "./AdminCustomersList.vue?vue&type=script&lang=ts&"
export * from "./AdminCustomersList.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCustomersList.vue?vue&type=style&index=0&id=7fe567c0&lang=scss&scoped=true&"
import style1 from "./AdminCustomersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe567c0",
  null
  
)

export default component.exports